import { render } from "./MshelLogistics.vue?vue&type=template&id=368d69d4&scoped=true"
import script from "./MshelLogistics.vue?vue&type=script&lang=js"
export * from "./MshelLogistics.vue?vue&type=script&lang=js"

import "./MshelLogistics.vue?vue&type=style&index=0&id=368d69d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368d69d4"]])

export default __exports__